/* eslint-disable max-len */
/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	session            : {},
	initialSession     : 0,
	prevSession        : {},
	subCatList         : [],
	// profileData       : [],
	certificate        : {},
	certificateTab     : 0,
	contentView        : {},
	countDown          : {},
	notificationCount  : 0,
	initialStatus      : 0,
	dealConnection     : 0,
	dealStatus         : true,
	deal               : { dealConnection: 1, dealStatus: true },
	eventComments      : null,
	companyProfile     : {},
	notification       : [],
	sharePost          : '',
	bpsnotification    : '',
	sideMenuData       : [],
	contractAccessData : {},
	configs           	: { feedManagement: {} },
	userConfigs       	: {},
	otherConfigs       : {}

};

export const userSessionSlice = createSlice({
	name     : 'session',
	initialState,
	reducers : {
		getDealConnection : (state, action) =>
		{
			state.dealConnection = action.payload;
		},
		getDealData : (state, action) =>
		{
			state.deal = { dealConnection: action.payload.dealConnection, dealStatus: action.payload.dealStatus };
		},
		getUserSession : (state, action) =>
		{
			const existing = state.session?.companyData;

			state.session = action.payload;
			if (existing && !action.payload?.companyData && action.payload && typeof action.payload === 'object' && Object.keys(action.payload).length > 0)
			{
				state.session.companyData = existing;
			}
		},
		getPrevSession : (state, action) =>
		{
			state.prevSession = action.payload;
		},
		currSubCatlist : (state, action) =>
		{
			state.subCatList = action.payload;
		},
		getProfileData : (state, action) =>
		{
			const existing = state.session?.companyData;

			state.session = Object.assign(state.session, action.payload);
			if (existing && !action.payload?.companyData)
			{
				state.session.companyData = existing;
			}
		},
		getEditCertificate : (state, action) =>
		{
			// eslint-disable-next-line no-return-assign
			state.certificate = action.payload;
		},
		getCertificateTabV : (state, action) =>
		{
			state.certificateTab = action.payload;
		},
		updateSeries : (state, action) =>
		{
			state.session = { ...state.session, empIdSeries: action.payload };
		},
		updateCompanyProfile : (state, action) =>
		{
			const existing = state.session?.companyData;

			state.session = Object.assign(state.session, action.payload);
			if (existing && !action.payload?.companyData)
			{
				state.session.companyData = existing;
			}
		},
		getCountDown : (state, action) =>
		{
			state.countDown = action.payload;
		},
		selectedContentData : (state, action) =>
		{
			state.contentView = action.payload;
		},
		getNotification : (state, action) =>
		{
			state.notificationCount = action.payload;
		},
		initialChatFetchApi : (state, action) =>
		{
			state.initialStatus = action.payload;
		},
		getEventFromCarousel : (state, action) =>
		{
			state.eventComments = action.payload;
		},
		getCompanyProfileData : (state, action) =>
		{
			state.companyProfile = action.payload === 'clear' ? {} : { ...state.companyProfile, ...action.payload };
		},
		getNotificationRedux : (state, action) =>
		{
			state.notification = action.payload;
		},
		getSessionCount : (state, action) =>
		{
			state.initialSession = action.payload;
		},
		getSharedItem : (state, action) =>
		{
			state.sharePost = action.payload;
		},
		updateBpsNotification : (state, action) =>
		{
			state.bpsnotification = action.payload;
		},
		updateSideMenu : (state, action) =>
		{
			state.sideMenuData = action.payload;
		},
		updateContractData : (state, action) =>
		{
			state.contractAccessData = action.payload;
		},
		updateConfigs : (state, action) =>
		{
			state.configs = action.payload;
		},
		updateUserConfigs : (state, action) =>
		{
			state.userConfigs = action.payload;
		},
		updateOtherConfigs : (state, action) =>
		{
			state.otherConfigs = action.payload;
		},
		updateConfiguration : (state, action) =>
		{
			action.payload.type === 'user'
				? state.userConfigs = { ...state.userConfigs, ...action.payload.data }
				: state.configs = { ...state.configs, ...action.payload.data };
		},
		resetUserSession : () =>
		{
			return initialState;
		}
	}
});

export const
	{
		getSessionCount, getUserSession, updateSeries, getDealConnection,
		currSubCatlist, getProfileData, getEditCertificate, getPrevSession,
		updateSideMenu, getCertificateTabV, getCountDown, selectedContentData,
		setContentModuleList, getNotification, initialChatFetchApi, getDealData,
		getEventFromCarousel, updateCompanyProfile, getCompanyProfileData, getNotificationRedux,
		getSharedItem, updateBpsNotification, updateContractData, updateConfigs, updateUserConfigs,
		updateOtherConfigs, updateConfiguration, resetUserSession
	} = userSessionSlice.actions;
export default userSessionSlice.reducer;